import { ulid } from "ulid";

export type UnsubscribeFunction = () => void;

type Callback<Args extends unknown[]> = (...args: Args) => void;

export class SubscriberRegistry<CallbackArgs extends unknown[] = []> {
    private subscriberMap: Map<string, Callback<CallbackArgs>> = new Map();

    public subscribe(callback: Callback<CallbackArgs>): UnsubscribeFunction {
        const key = ulid();
        this.subscriberMap.set(key, callback);

        return () => this.subscriberMap.delete(key);
    }

    public broadcast(...args: CallbackArgs): void {
        Array.from(this.subscriberMap.values()).forEach((callback) => callback(...args));
    }
}
